import { LucideIcon } from 'lucide-react';
import { Card } from '../../ui/card';

interface SummarySectionCardProps {
  title: string;
  icon: LucideIcon;
  children: React.ReactNode;
  error?: string | null;
}

export function SummarySectionCard({ title, icon: Icon, children, error }: SummarySectionCardProps) {
  return (
    <Card className="p-6 border-l-4 border-[#00758d]">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-10 h-10 rounded-lg bg-[#00758d] flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900">{title}</h3>
          {error && (
            <p className="text-sm text-[#8E0B56] mt-1 flex items-center gap-1">
              <span>⚠️</span> {error}
            </p>
          )}
        </div>
      </div>
      <div className="ml-14">{children}</div>
    </Card>
  );
}
